import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRotateCounterClockwise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowRotateCounterClockwise"><Path d="M5.4998 7.00891C7.32073 4.95438 9.20364 3.75 12.0208 3.75C16.5771 3.75 20.2708 7.44365 20.2708 12C20.2708 16.5563 16.5771 20.25 12.0208 20.25C8.42869 20.25 5.37278 17.9543 4.24023 14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M4.75 4V7C4.75 7.55228 5.19772 8 5.75 8H8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowRotateCounterClockwise;
